(function(){
    const show = document.querySelector('[reveal-js] .text-gradient'),
          section = show.closest('section'),
          number = Number(show.innerText) + 1;
    var   counter = 7000;
    if ("IntersectionObserver" in window) {
        let counterObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    counter_js();
                    counter = 7000;
                    section.classList.add('inView');
                    // counterObserver.unobserve(entry.target);
                }else{
                    section.classList.remove('inView');
                }
            });
        });
        counterObserver.observe(section);									
    } else {
      counter_js();
    }
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            // rect.left >= 0 &&
            rect.bottom <= ((window.innerHeight + rect.height) || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    function counter_js(){
          counter = counter + 9;
           if ( counter < number ) {
             show.innerHTML = counter.toString();
             setTimeout(function(){
                 counter_js();
             }, 1)    
           }else{
             show.innerHTML = (number -1).toString();
           } 
    }
    var button = document.querySelector('.section-stack__intro .button');
    button.addEventListener("click", function(event){
        event.preventDefault();
        var featuredProduct = document.querySelector('.shopify-section--featured-product');
        if(featuredProduct){
          featuredProduct.scrollIntoView({block: 'start', inline: "nearest", behavior: 'smooth'});
        }
    });
    document.querySelectorAll('.shopify-section--slideshow .button').forEach( button => {
      button.addEventListener("click", function(event){
        event.preventDefault();
        var featuredProduct = document.querySelector('.shopify-section--featured-product');
        if(featuredProduct){
          featuredProduct.scrollIntoView({block: 'start', inline: "nearest", behavior: 'smooth'});
        }
      });
    });
  

     const featureChart = document.querySelector('.shopify-section--feature-chart');
    if ("IntersectionObserver" in window) {
        let counterObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    featureChart.classList.add('inView');
                }else{
                    featureChart.classList.remove('inView');
                }
            });
        });
        counterObserver.observe(featureChart);									
    }
})()